module.exports = __webpack_public_path__ + "images/advanced-specialization.png";